import { Box } from '@mui/material'
import Header from 'components/header'
import Sidebar from 'components/sidebar'
import React from 'react'

function Quizzes() {
    return (
        <Box sx={{ display: 'flex' }}>
            <Sidebar />
            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', width: '100%' }}>
                <Header />
                Quizzes Page
            </Box>
        </Box>
    )
}

export default Quizzes

